module.exports = __webpack_public_path__ + "dabc01f2585675ffc6fd414fc57b2b9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Products/ProductSummary/Empty/img.jpg
// module id = ./src/views/Products/ProductSummary/Empty/img.jpg
// module chunks = 0